import React from 'react';
import PropTypes from 'prop-types';
var TreeNothingFound = /*#__PURE__*/React.memo(function () {
  return /*#__PURE__*/React.createElement("div", {
    className: "TreeTreeNothingFound display-flex justify-content-center text-size-20\n                padding-top-25 margin-top-25 margin-bottom-25"
  }, /*#__PURE__*/React.createElement("span", {
    className: 'rioglyph rioglyph-looking-glass-man text-size-400pct text-color-light'
  }));
});
TreeNothingFound.displayName = 'TreeNothingFound';
TreeNothingFound.defaultProps = {};
TreeNothingFound.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string
};
export default TreeNothingFound;